// extracted by mini-css-extract-plugin
module.exports =  {"kebab":"akDU_zEmnSF7HzNXUxbX"};